import RulesTab from './tournament/RulesTab';

const RulesOnlyTournamentView = ({ tournament }) => (
  <div className="mx-auto max-w-screen-md">
    <RulesTab html={tournament.rules} />
  </div>
);

export default RulesOnlyTournamentView;
